const sliderRouter = {
  path: '/slider',
  component: () => import('@/views/cms/slider/index'), // Parent router-view
  name: 'Slider',
  meta: {
    title: '官网首页轮播图管理',
    icon: 'el-icon-postcard',
    roles: ['root', 'market', 'business']
  },
  children: [
    {
      path: 'table',
      name: 'SliderTable',
      component: () => import('@/views/cms/slider/table'),
      meta: { title: '首页轮播图管理', icon: 'el-icon-picture', roles: ['root', 'market', 'business'], noCache: false }
    }
  ]
}
export default sliderRouter
